var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIlBlogs2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 689,
    height: 698,
    viewBox: "0 0 689 698",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M270 190.293C300.279 169.902 336.749 158 376 158C480.934 158 566 243.066 566 348C566 410.161 536.149 465.35 490 500.014",
    stroke: "#38F9C5",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M270 190.293C300.279 169.902 336.749 158 376 158C480.934 158 566 243.066 566 348C566 410.161 536.149 465.35 490 500.014",
    stroke: "#38F9C5",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M228.077 228.69C191.407 273.261 175.415 333.934 190.077 394.341C214.828 496.314 317.558 558.916 419.531 534.165C435.363 530.323 450.246 524.6 464 517.293",
    stroke: "#5C1FDE",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M280 132.343C309.328 119.268 341.815 112 376 112C506.339 112 612 217.661 612 348C612 433.692 566.329 508.716 498 550.061",
    stroke: "#38F9C5",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M235.243 157.387C171.123 204.998 132.741 284 140.832 369.309C153.14 499.066 268.306 594.277 398.063 581.97C417.388 580.137 435.948 576.022 453.5 569.917",
    stroke: "#5C1FDE",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M280 132.343C309.328 119.268 341.815 112 376 112C506.339 112 612 217.661 612 348C612 433.692 566.329 508.716 498 550.061",
    stroke: "#38F9C5",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M296 71.2565C321.399 63.9273 348.241 60 376 60C535.058 60 664 188.942 664 348C664 459.482 600.658 556.17 508 604.036",
    stroke: "#38F9C5",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M449.107 626.34C423.591 633.25 396.688 636.735 368.933 636.279C209.896 633.663 83.092 502.619 85.7076 343.582C87.5408 232.115 152.464 136.482 245.897 90.1455",
    stroke: "#5C1FDE",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M296 71.2565C321.399 63.9273 348.241 60 376 60C535.058 60 664 188.942 664 348C664 459.482 600.658 556.17 508 604.036",
    stroke: "#38F9C5",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M313 9.75593C333.424 5.97581 354.481 3.99998 376 3.99998C565.986 3.99998 720 158.014 720 348C720 488.907 635.281 610.027 514 663.201",
    stroke: "#38F9C5",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M406.174 691.976C385.487 693.846 364.337 693.861 342.912 691.866C153.744 674.252 14.6729 506.621 32.2877 317.454C45.3521 177.154 140.936 64.4103 266.625 22.7098",
    stroke: "#5C1FDE",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M313 9.75593C333.424 5.97581 354.481 3.99998 376 3.99998C565.986 3.99998 720 158.014 720 348C720 488.907 635.281 610.027 514 663.201",
    stroke: "#38F9C5",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 204,
    r: 12,
    fill: "#38F9C5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 204,
    r: 12,
    fill: "#38F9C5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 259,
    cy: 142,
    r: 12,
    fill: "#38F9C5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 259,
    cy: 142,
    r: 12,
    fill: "#38F9C5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 79,
    r: 12,
    fill: "#38F9C5"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 79,
    r: 12,
    fill: "#38F9C5"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 16,
    r: 12,
    fill: "#38F9C5"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 16,
    r: 12,
    fill: "#38F9C5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlBlogs2);
export default __webpack_public_path__ + "static/media/il_blogs2.241033cac19c3c8742983c14883d343c.svg";
export { ForwardRef as ReactComponent };